<div class="modal-header">
    <h3 class="modal-title" id="modal-title-id" id="modal-title-id">{{title}}</h3>
</div>
<div class="modal-body">
    <span [innerHTML]="trustedMsg"></span>
</div>
<div class="modal-footer">
	<button class="btn btn-default" type="button" (click)="cancel()">{{LOCALIZATION.cancel}}</button>
	<ng-container *ngFor="let btn of customBtns">
	    <button
	      [class]="btn.class"
	      (click)="btn.callback ? btn.callback() : null">
	      {{ btn.title }}
	    </button>
	</ng-container>    
    <button class="btn" [class]="buttonClass" type="button" (click)="proceed()">{{LOCALIZATION.ok}}</button>
</div>
